export default __webpack_public_path__ + "static/media/Upload-Play.4de2e527.gif";